import type { ComponentType } from '@angular/cdk/portal';
import type { TemplateRef } from '@angular/core';

export enum PalantirDialogSizeEnum {
  '2x-large' = '2x-large',
  'large' = 'large',
  'medium' = 'medium',
  'small' = 'small',
  'x-large' = 'x-large',
}

export type PalantirDialogSize = keyof typeof PalantirDialogSizeEnum;

export interface PalantirDialogConfirmation<
  T = ComponentType<unknown> | TemplateRef<unknown>,
  R = T extends ComponentType<infer C> | TemplateRef<infer C> ? C : unknown,
> {
  confirm?(): Promise<boolean> | boolean;
  evaluate(componentInstance: R): boolean;
}

export interface PalantirDialogOptions {
  autoFocus?: boolean;
  canClose?(): Promise<boolean> | boolean;
  confirmation?: PalantirDialogConfirmation;
  data?: any;
  fullHeight?: boolean;
  size?: PalantirDialogSize;
}
